import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GroupsUsers, Users } from "../../interfaces/groups-user.interface";
import { EmailsGroups } from "../../components/modal-add-users-groups/modal-add-users-groups.component";

@Injectable({
  providedIn: "root",
})
export class GroupsUsersService {
  constructor(private http: HttpClient) {}

  getGroupsUsers(pk: string, sk: string): Observable<{ data: GroupsUsers[] }> {
    const url = localStorage.getItem("url");
    return this.http.get<{ data: GroupsUsers[] }>(`${url}/groups/${pk}/${sk}/details`);
  }
  addGroup(name: string, parentSk: string, picture: string) {
    const url = localStorage.getItem("url");
    return this.http.post(`${url}/groups/`, {
      emailTemplade: "",
      name,
      parentSk,
      picture,
    });
  }
  deleteUsers(
    users: string[],
    emails: string[],
    group: { pk: string; sk: string }
  ): Observable<{ data: { data: Users }[]; invitationsDeleted: Users[] }> {
    const url = localStorage.getItem("url");
    return this.http.patch<{ data: { data: Users }[]; invitationsDeleted: Users[] }>(
      `${url}/users/groups/${group.pk}/${group.sk}`,
      {
        users,
        emails,
      }
    );
  }
  validateEmail(email: string): Observable<any> {
    const url = localStorage.getItem("url");
    return this.http.get(`${url}/users/params/validation?_email=${email}`);
  }
  sendInvitation(
    users: EmailsGroups[],
    groups: { pk: string; sk: string; color: string; skStatus: string }[]
  ) {
    const url = localStorage.getItem("url");
    return this.http.post<any>(`${url}/invitation`, { users, groups });
  }

  reSendInvitation(email: string, status: string, groupPk: string, groupSk: string) {
    const url = localStorage.getItem("url");
    return this.http.post(`${url}/invitation/resending`, {
      email,
      groupPk,
      groupSk,
      status,
    });
  }

  updateUserRole(user: Users, status: string, group: GroupsUsers) {
    const url = localStorage.getItem("url");
    return this.http.patch(`${url}/users/${user.pk}/${user.sk}`, {
      modifyGroups: false,
      modifyStatus: true,
      fullName: user.fullName,
      password: null,
      phone: user.phone,
      groups: [
        {
          pk: group.group.pk,
          sk: group.group.sk,
          status,
          color:
            group.group.roles.find((group) => group.properties.name === status)?.properties.color ||
            "#E0FAD9",
        },
      ],
    });
  }
}
